import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  });
}

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: () => import('./views/Welcome.vue')
    },
    {
      path: '/login/:clientId?',
      name: 'Login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/registration/:registerId',
      name: 'Register',
      component: () => import('./views/Register.vue')
    },
    {
      path: '/password/:resetKey',
      name: 'ResetPassword',
      component: () => import('./views/ResetPassword.vue')
    },
    {
      path: '/dashboard/:clientId?',
      name: 'Dashboard',
      component: () => import('./views/Dashboard.vue')
    },
    {
      path: '/superadmin',
      name: 'Superadmin',
      component: () => import('./views/Superadmin.vue')
    },
    {
      path: '/course/:courseId',
      name: 'Course',
      component: () => import('./components/Course.vue')
    },
    {
      path: '/survey',
      name:'Survey',
      component: () => import('./components/Survey.vue')
    }
  ]
})
